import React from 'react'
import ActualStreams from './HomepageSection/Sections/ActualStreams';
import DatabaseStreams from './HomepageSection/Sections/DatabaseStreams';

export default function HomePageContent() {
    return (
        <>
            <h3 className="mb-5">HomePage</h3>
            <ActualStreams/>
            <DatabaseStreams/>
            <button className="form__item form--button m-5" onClick={()=>{localStorage.clear(); window.location.reload()}}>log out</button>
        </>
    )
}
